export default function fallbackFormatter(v: unknown) {
  return `${v}`;
}
